import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { FullScreenSpinner } from '../components/ui/Spinner';

export default function RequireAuth({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <FullScreenSpinner />;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
